import style from "./ChipGroup.module.scss";

export const ChipGroup = ({ name, options, selected, onToggle, disabled = false }) => (
  <div className={style.chips} role="group" aria-label={name}>
    {options.map((o) => (
      <button
        key={o.key}
        type="button"
        data-testid={`${name}-${o.key}`}
        className={style.chip}
        aria-pressed={(selected || []).includes(o.key)}
        disabled={disabled}
        onClick={() => onToggle(o.key)}
      >
        {o.value}
      </button>
    ))}
  </div>
);
